import { keepPreviousData, queryOptions, useQuery } from "@tanstack/react-query";
import { qk } from "@/lib/query-keys";
import {
  listarTiposDocumentoAdmin,
  type ListarTiposDocumentoParams,
} from "../services/tipos-documento-service";

/**
 * Listado PAGINADO (server-side) del catálogo de tipos de documento ·
 * búsqueda + página en el queryKey. Las mutations invalidan por prefijo
 * `qk.adminTiposDocumento`, que cubre todas las variantes de params.
 */
export const tiposDocumentoAdminQueryOptions = (
  params: ListarTiposDocumentoParams = {}
) =>
  queryOptions({
    queryKey: [...qk.adminTiposDocumento, params] as const,
    queryFn: () => listarTiposDocumentoAdmin(params),
    placeholderData: keepPreviousData,
  });

export function useTiposDocumentoAdmin(params: ListarTiposDocumentoParams = {}) {
  return useQuery(tiposDocumentoAdminQueryOptions(params));
}
